module.exports = __webpack_public_path__ + "static/media/stellated_dodecahedron_2.7d91d1ce.png";